import {
  IPeerGroupsProps,
  getPeerGroupData,
  IFilter,
} from "app/components/visualizations/PeerGroups/lib/http";
import * as React from "react";
import { Row, Col, Panel } from "react-bootstrap";
import { AverageTrustees } from "app/components/visualizations/PeerGroups/Other/AverageTrustees";
import { PaidTrusteesOrOfficers } from "app/components/visualizations/PeerGroups/Other/PaidTrusteesOrOfficers";
import { Offices } from "app/components/visualizations/PeerGroups/Other/Offices";
import { Employees } from "app/components/visualizations/PeerGroups/Other/Employees";
import { TabHeader } from "app/components/tabs/header";
import { SubHeader } from "app/components/tabs/SubHeader";
import TabFootnote from "app/components/tabs/TabFootnote";
import {formatAmount} from "../../../components/data/utils/funcs";

export interface IOtherState {
  data: any[];
  currentPeerGroup: any[];
  filters: IFilter;
}

export class Other extends React.Component<IPeerGroupsProps, IOtherState> {
  state: IOtherState = {
    data: [],
    currentPeerGroup: [],
    filters: { assetLevel: 0 },
  };

  componentDidMount() {
    this.pullData(this.props.filters);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel) {
      this.setState({ filters: this.props.filters }, () => {
        this.pullData(this.props.filters);
      });
    }
  }

  pullData(filters: IFilter) {
    const requestBody = {
      action: "getOtherTab",
      request: { assetLevel: filters.assetLevel },
    };
    getPeerGroupData(requestBody).then((response: any[]) => {
      const currentPeerGroup = response.find(
        (dataPoint, index) =>
          dataPoint.filterId === this.props.filters.assetLevel
      );
      this.setState({ data: response, currentPeerGroup });
    });
  }

  render() {
    const { currentPeerGroup, data } = this.state;

    return (
      <div>
        <TabHeader filters={this.props.filters} label="Trustees / Other"/>
        <SubHeader label={currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeTitle"]}/>
        <Row>
          <Col sm={12} className="text-center">
            <h4 className="text-primary">
              {currentPeerGroup && formatAmount(Number(currentPeerGroup["Other_T_B_Placeholder1"]))}
              &nbsp;
              <small style={{color: "#333"}}>
                {currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText1"]}
              </small>
              &nbsp;
              {currentPeerGroup && formatAmount(Number(currentPeerGroup["Other_T_B_Placeholder2"]))}
              &nbsp;
              <small style={{color: "#333"}}>
                {currentPeerGroup && currentPeerGroup["Other_T_B_Placeholder3"]}
              </small>
            </h4>
          </Col>
        </Row>
        <Row style={{marginTop: "1.0rem"}}>
          <Col
            sm={12}
            md={4}
            className="fontSize1_7"
            style={{padding: "35px"}}
          >
            <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeIntro"]}</p>
            <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText3"]}</p>
          </Col>
          <Col sm={12} md={8}>
            <Panel>
              <div className="panel-body">
                <Row>
                  <Col sm={12}>
                    <AverageTrustees data={data} filters={this.props.filters}/>
                  </Col>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText2"]}</p>
                  </Col>
                </Row>
              </div>
            </Panel>
          </Col>
        </Row>
        <SubHeader label={currentPeerGroup && currentPeerGroup["Other_T_B_Placeholder4"]}/>
        <Row>
          <Col sm={12} md={9}>
            <PaidTrusteesOrOfficers data={data} filters={this.props.filters}/>
          </Col>
          <Col sm={12} md={3}>
            <Panel>
              <div className="panel-body text-center">
                {currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText4"]}
              </div>
              <div className="panel-body">
                <Row>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText5"]}</p>
                  </Col>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText6"]}</p>
                  </Col>
                </Row>
              </div>
            </Panel>
          </Col>
        </Row>
        <SubHeader label={currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText7"]}/>
        <Row>
          <Col sm={12} md={3}>
            <Panel>
              <div className="panel-body text-center">Have Offices?</div>
              <div className="panel-body">
                <Row>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText8"]}</p>
                  </Col>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText9"]}</p>
                  </Col>
                </Row>
              </div>
            </Panel>
          </Col>
          <Col sm={12} md={9}>
            <Offices data={data} filters={this.props.filters}/>
          </Col>
          <Col sm={12}>
            <TabFootnote>
              <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText10"]}</p>
            </TabFootnote>
          </Col>
        </Row>
        <SubHeader label={currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText11"]}/>
        <Row>
          <Col sm={12} md={9}>
            <Employees data={data} filters={this.props.filters}/>
          </Col>
          <Col sm={12} md={3}>
            <Panel>
              <div className="panel-body text-center">
                {currentPeerGroup && currentPeerGroup["Other_T_B_EmployeesTitle"]}
              </div>
              <div className="panel-body">
                <Row>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText12"]}</p>
                  </Col>
                  <Col sm={12}>
                    <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText13"]}</p>
                  </Col>
                </Row>
              </div>
            </Panel>
          </Col>
          <Col sm={12}>
            <TabFootnote>
              <p>{currentPeerGroup && currentPeerGroup["Other_T_B_TrusteeText14"]}</p>
            </TabFootnote>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/PeerGroups/tabs/Other.tsx